<div class="pane-container" [ngClass]="{'panes-adjusted': panesLimit}">
  <div class="pane-wrapper" asgPaneIndex [paneIndex]="0"
  [ngClass]="{
    'active-pane': activePaneIndex === 0,
    'active-pane--double': isDoublePanes
  }">
    <div class="as-tabs__container">
      <ul class="as-tabs" role="tablist">
        @for (tab of tabs | async; track tab.id; let i = $index) {
          @if (tab.paneIndex === 0) {
            <li class="as-tab "
              [ngClass]="{'as-tab--active': tab.isActive, 'hidden': tab.isHidden}"
              [asgClickHandler]="selectTab"
              [asgClickParams]="tab"
              [asgardFeature]="AsgardFeatureNames.SELECT_TAB">
              {{tab.title | translate}}
              @if (!isExamFile(i)) {
                <i class="fas fa-times" [asgClickHandler]="closeTab" [asgClickParams]="tab"
                asgTooltip="COMMON.CLOSE_TAB"></i>
              }
            </li>
          }
        }
        <!-- create new tab -->
        <li class="as-tab--new"
          [asgClickHandler]="addNewTab"
          [asgardFeature]="AsgardFeatureNames.NEW_TAB"
          asgTooltip="COMMON.ADD_TAB"
          [ngClass]="{'hidden': examRestrictionsAreActive}">
          <i class="fas fa-plus"></i>
        </li>
      </ul>
    </div>
    @if ((tabs | async)?.length === 0) {
      <asg-no-tab-bottom-toolbar></asg-no-tab-bottom-toolbar>
    }

  </div>
  @if (panesLimit) {
    <div class="pane-wrapper" asgPaneIndex [paneIndex]="1"
    [ngClass]="{
      'active-pane': activePaneIndex === 1,
      'active-pane--double': isDoublePanes
    }">
      <div class="as-tabs__container">
        <ul class="as-tabs" role="tablist">
          @for (tab of tabs | async; track tab.id) {
            @if (tab.paneIndex === 1) {
              <li class="as-tab "
                [ngClass]="{'as-tab--active': tab.isActive, 'hidden': tab.isHidden}"
                [asgClickHandler]="selectTab"
                [asgClickParams]="tab"
                [asgardFeature]="AsgardFeatureNames.SELECT_TAB">
                {{tab.title | translate}}
                <i class="fas fa-times" [asgClickHandler]="closeTab" [asgClickParams]="tab"
                asgTooltip="COMMON.CLOSE_TAB"></i>
              </li>
            }
          }
          <!-- create new tab -->
          <li class="as-tab--new"
            [asgClickHandler]="addNewTab"
            [asgardFeature]="AsgardFeatureNames.NEW_TAB"
            asgTooltip="COMMON.ADD_TAB"
            [ngClass]="{'hidden': examRestrictionsAreActive}">
            <i class="fas fa-plus"></i>
          </li>
        </ul>
      </div>
      @if ((tabs | async)?.length === 0) {
        <asg-no-tab-bottom-toolbar></asg-no-tab-bottom-toolbar>
      }
    </div>
  }
</div>

@defer {
  @for (tab of tabs | async; track tab.id) {
    <asg-tab [tabData]="tab" [panesLimit]="panesLimit" [activePaneIndex]="activePaneIndex" [ngClass]="{'hidden': tab.isHidden}"> </asg-tab>
  }
}
